import { createVNode } from "vue";
import PropTypes from '../_util/vue-types';
import { getSlot } from '../_util/props-util';
var ILazyRenderBoxPropTypes = {
  visible: PropTypes.bool,
  hiddenClassName: PropTypes.string,
  forceRender: PropTypes.bool
};
export default {
  props: ILazyRenderBoxPropTypes,
  render: function render() {
    return createVNode("div", null, [getSlot(this)]);
  }
};